import get from 'lodash.get';
import { Controller, ControllerProps, useFormContext } from 'react-hook-form-lts';
import { FieldValues } from 'react-hook-form-lts/dist/types';
import { useIntl } from 'react-intl';

import { getControllerErrorText } from '../../ui/Input/utils';
import { FormTextField, FormTextFieldProps } from './FormTextField';

export type ControlTextFieldProps<TFieldValues extends FieldValues = FieldValues> = Omit<
  ControllerProps<TFieldValues>,
  'render'
> &
  FormTextFieldProps;
export const ControlTextField = <TFieldValues extends FieldValues = FieldValues>({
  control: propsControl,
  ...props
}: ControlTextFieldProps<TFieldValues>) => {
  const { $t } = useIntl();
  const { control: contextControl, formState } = useFormContext<TFieldValues>();
  const control = propsControl ?? contextControl;

  return (
    <Controller
      control={control}
      render={({ field, fieldState }) => {
        const error = get(formState.errors, field.name);
        const hasError = props.error || Boolean(error);
        const errorMessage = getControllerErrorText(error, $t);

        return (
          <FormTextField
            {...props}
            {...props.rules}
            inputRef={field.ref}
            required={Boolean(props.rules?.required)}
            {...field}
            error={hasError}
            helperText={errorMessage}
          />
        );
      }}
      {...props}
    />
  );
};
